module.exports = __webpack_public_path__ + "img/caas1m-m@2.037cfb5b.jpg";